import { useState } from 'react'
import { saveAiIncident, type AiAgentShell, type AiIncidentRow } from '../../api/settingsAiAgent'
import { failed, NoteText, type Note } from './parts'

/**
 * Fila "Incident catalog" - numai la Global.
 *
 * Aici, si numai aici, se hotaraste ce are voie agentul sa execute FARA
 * semnatura pe instanta. Admin-ul bifeaza CLASA si scrie COMANDA care chiar
 * ruleaza: modelul nu poate strecura continut - ce e in coloana ruleaza, orice
 * altceva se refuza. Lista porneste goala, si fiecare bifa intra in jurnal.
 */
export function IncidentTab({ page }: { page: AiAgentShell }) {
  return (
    <div className="panel panel-default">
      <div className="panel-body">
        <strong style={{ fontSize: 13 }}>Incident mode catalog</strong>
        <p className="text-muted" style={{ fontSize: 12, margin: '6px 0 10px' }}>
          The actions the agent may run <strong>straight away</strong> in Incident mode. The command written here is
          the one that runs - the agent cannot send another. The list starts empty; every tick goes into the journal.
        </p>

        {page.catalog === null ? (
          <div className="text-muted" style={{ fontSize: 12 }}>
            The catalog columns are missing - apply the migrations under{' '}
            <a href="/app/settings/change_log">Change Log → Database migrations</a>.
          </div>
        ) : page.catalog.length === 0 ? (
          <div className="text-muted" style={{ fontSize: 12 }}>
            The command catalog is empty.
          </div>
        ) : (
          <table className="table table-condensed" style={{ fontSize: 12, marginBottom: 0 }}>
            <thead>
              <tr>
                <th style={{ width: 70 }}>Type</th>
                <th style={{ width: 220 }}>Action</th>
                <th style={{ width: 90 }}>incident_safe</th>
                <th>Command that runs</th>
                <th style={{ width: 90 }}></th>
              </tr>
            </thead>
            <tbody>
              {page.catalog.map((row) => (
                <IncidentRow key={row.ID} row={row} />
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )
}

function IncidentRow({ row }: { row: AiIncidentRow }) {
  const [safe, setSafe] = useState(Number(row.incident_safe) === 1)
  const [command, setCommand] = useState(row.incident_command ?? '')
  const [note, setNote] = useState<Note | null>(null)

  const save = () => {
    setNote({ text: '…' })
    void saveAiIncident({ id: row.ID, incident_safe: safe ? 1 : 0, incident_command: command })
      .then((r) => setNote(r.ok ? { text: 'Saved' } : { text: r.error ?? 'Failed', bad: true }))
      .catch((e: unknown) => setNote({ text: failed(e), bad: true }))
  }

  return (
    <tr>
      <td>
        <code>{row.command_type}</code>
      </td>
      <td>{row.command_title}</td>
      <td style={{ textAlign: 'center' }}>
        <input type="checkbox" checked={safe} onChange={(e) => setSafe(e.target.checked)} />
      </td>
      <td>
        <textarea
          className="form-control"
          rows={1}
          style={{ fontFamily: 'monospace', fontSize: 11 }}
          placeholder="empty = the type is sent with no body"
          value={command}
          onChange={(e) => setCommand(e.target.value)}
        />
      </td>
      <td>
        <button type="button" className="btn btn-default btn-xs" onClick={save}>
          Save
        </button>
        <div style={{ fontSize: 11 }}>
          <NoteText note={note} />
        </div>
      </td>
    </tr>
  )
}
